import React from "react";


const NoMatch = () => (
  <h2 style={{textAlign: "center"}}>404 Sorry, this page was lost.</h2>
);

export default NoMatch;
